import React from "react";
import { useState, useEffect } from "react";
import "../index.css";
import imageUp from "../Variant3.png";

function UploadImage({ getImageFile }) {
  const [image, setImage] = useState();

  function onImageChange(e) {
    setImage(e.target.files[0]);
    getImageFile(e.target.files[0]);
  }

  useEffect(() => {
    if (!image) return;
    const newImageUrl = URL.createObjectURL(image);
  }, [image]);

  return (
    <div className="image-upload">
      <label htmlFor="file-input">
        <img src={imageUp} />
      </label>
      <input
        id="file-input"
        type="file"
        accept="image/*"
        onChange={onImageChange}
      ></input>
    </div>
  );
}

export default UploadImage;
